module.exports = __webpack_public_path__ + "img/abgc10.b0ef511f.jpg";